function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import merge from "lodash/merge";
import logger, { LapelError } from "../logger";
import { delivery, adobeValues } from "../utils/lpe-cache/apis/delivery";
/**
 * Encodes profile parameter keys to support complex object values.
 * This is done by simply encoding root key value with encodeURI as
 * adobe seems to like that.
 *
 * @param {object} profileParameters
 */ export function encode(profileParameters) {
    if (!profileParameters || typeof profileParameters !== "object") {
        return {};
    }
    return Object.entries(profileParameters).reduce(function(previous, param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        return _extends({}, previous, _define_property({}, key, encodeURI(String(value))));
    }, {});
}
/**
 * Decodes profile parameters encoded to support arbitary strings as values.
 * This is done by converting the value back from a uri encoded string.
 * @param {object} profileParameters
 */ export function decode(profileParameters) {
    if (!profileParameters || typeof profileParameters !== "object") {
        return {};
    }
    return Object.entries(profileParameters).reduce(function(previous, param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        return _extends({}, previous, _define_property({}, key, decodeURI(String(value))));
    }, {});
}
/**
 * Creates a new profile manager instance that should be shared
 * throughout your application.
 */ function createProfileManager() {
    var raiseEvent = /**
   * Raise an event and invoke the subscribed callbacks.
   * @param {string} event The event to raise
   * @param {*} data The data passed to the callbacks
   */ function raiseEvent(event, data) {
        if (cache.events[event]) {
            Array.from(cache.events[event].values()).forEach(function(callback) {
                try {
                    callback(data);
                } catch (error) {
                    logger.error(new LapelError("Error in profile manager event " + event + " callback", {
                        cause: error
                    }));
                }
            });
        }
    };
    var getProfile = /**
   * Get the current value of a profile.
   * @param {string} mbox The mbox /profile name
   */ function getProfile(mbox) {
        return cache.profiles[mbox] || {};
    };
    var on = /**
   * Subscribe to an event.
   * @param {"profiles-changed"} event The event to subscribe to
   * @param {*} callback The callback to be raised.
   * @returns {() => void} Unsubscribe the callback.
   */ function on(event, callback) {
        if (!cache.events[event]) {
            cache.events[event] = new Set();
        }
        cache.events[event].add(callback);
        return function() {
            cache.events[event].delete(callback);
        };
    };
    var postUpdate = /**
   * Post all queued updates to Adobe.
   */ function postUpdate() {
        // Bail if no updates queued
        if (cache.queuedUpdates.length === 0) {
            return;
        }
        var paramsToSend = {};
        // Mboxes that have new values
        var updatedMboxes = new Set();
        while(cache.queuedUpdates.length > 0){
            var _cache_queuedUpdates_shift = cache.queuedUpdates.shift(), mbox = _cache_queuedUpdates_shift.mbox, param = _cache_queuedUpdates_shift.param, value = _cache_queuedUpdates_shift.value;
            updatedMboxes.add(mbox);
            // Queue value for delivery
            paramsToSend[param] = value;
            // Apply the new value locally
            cache.profiles[mbox] = cache.profiles[mbox] || {};
            cache.profiles[mbox][param] = value;
        }
        // Emmit event with updated mboxes
        raiseEvent("profiles-changed", updatedMboxes);
        // Encode the profiles to support complex object values
        var profileParameters = encode(paramsToSend);
        // Fire and forget the delivery request
        var doDeliveryRequest = function() {
            return delivery({
                execute: {
                    mboxes: [
                        {
                            name: "update-peps-profile",
                            index: 0,
                            parameters: {
                                mbox3rdPartyId: adobeValues.thirdPartyId
                            },
                            profileParameters: profileParameters
                        }
                    ]
                }
            }).catch(function(error) {
                logger.error(new LapelError("Failed to post profile update", {
                    cause: error
                }));
            });
        };
        // Participate in the request queue.
        var requestPromise = cache.activeRequests.length > 0 ? cache.activeRequests[cache.activeRequests.length - 1].then(doDeliveryRequest) : doDeliveryRequest();
        requestPromise = requestPromise.then(filterRequests(requestPromise));
        cache.activeRequests.push(requestPromise);
    };
    var queueUpdate = /**
   * Queue an update to a mbox / profile.
   * @param {string} mbox
   * @param {object} value
   */ function queueUpdate(mbox, param, value) {
        cache.queuedUpdates.push({
            mbox: mbox,
            param: param,
            value: value
        });
        if (updateTimeout) {
            clearTimeout(updateTimeout);
        }
        updateTimeout = setTimeout(function() {
            postUpdate();
        }, 1); // TODO: What should the timeout be?
    };
    var doRequest = /**
   * Do a request for the latest mbox / profile values.
   */ function doRequest() {
        var mboxes = [];
        // Get the mboxes we want to retrieve data for
        Array.from(Object.entries(cache.mboxes)).forEach(function(param, index) {
            var _param = _sliced_to_array(param, 2), mbox = _param[0], cached = _param[1];
            // TODO: Do we want to add retry logic or just let things fail silently?
            if (cached.status !== "init" || cached.count < 1) {
                return;
            }
            cached.status = "fetch"; // eslint-disable-line
            mboxes.push({
                index: index,
                name: mbox,
                parameters: {
                    mbox3rdPartyId: adobeValues.thirdPartyId
                }
            });
        });
        // If no mboxes bail out
        if (mboxes.length === 0) {
            return Promise.resolve();
        }
        var doDeliveryRequest = function() {
            return delivery({
                execute: {
                    mboxes: mboxes
                }
            }).then(function(response) {
                var _response_execute, _response;
                // If there are no mboxes on the response set it to
                // the mboxes we set out so status is updated to ready
                var responseMboxes = ((_response = response) == null ? void 0 : (_response_execute = _response.execute) == null ? void 0 : _response_execute.mboxes) || mboxes;
                var updatedMboxes = new Set();
                responseMboxes.forEach(function(responseMbox) {
                    var _responseMbox_options_, _responseMbox_options;
                    var content = (_responseMbox_options = responseMbox.options) == null ? void 0 : (_responseMbox_options_ = _responseMbox_options[0]) == null ? void 0 : _responseMbox_options_.content;
                    cache.mboxes[responseMbox.name].status = "ready";
                    // Bail out if no content for mbox
                    if (!content) {
                        return;
                    }
                    updatedMboxes.add(responseMbox.name);
                    // Decode the content
                    var decodedContent = decode(content);
                    // Merge with any local state that's been set before
                    // request completes (very unlikely but should be handled).
                    cache.profiles[responseMbox.name] = cache.profiles[responseMbox.name] || {};
                    cache.profiles[responseMbox.name] = merge(decodedContent, cache.profiles[responseMbox.name]);
                });
                // Emmit event with updated mboxes
                raiseEvent("profiles-changed", updatedMboxes);
            }).catch(function(error) {
                logger.error(new LapelError("Failed to retrieve profile mboxes", {
                    cause: error
                }));
                // Set status to errored
                mboxes.forEach(function(mbox) {
                    cache.mboxes[mbox.name].status = "error";
                });
            });
        };
        // Participate in the request queue.
        var requestPromise = cache.activeRequests.length > 0 ? cache.activeRequests[cache.activeRequests.length - 1].then(doDeliveryRequest) : doDeliveryRequest();
        cache.activeRequests.push(requestPromise);
        requestPromise = requestPromise.then(filterRequests(requestPromise));
        return requestPromise;
    };
    var queueRequest = /**
   * Queue a request for registered mboxes / profiles.
   */ function queueRequest() {
        if (requestTimeout) {
            clearTimeout(requestTimeout);
        }
        requestTimeout = setTimeout(function() {
            doRequest();
        }, 1); // TODO: What should the timeout be?
    };
    var register = /**
   * Register an mbox / profile with the manager.
   * @param {string} mbox The mbox / profile
   */ function register(mbox) {
        cache.mboxes[mbox] = cache.mboxes[mbox] || {
            count: 0,
            status: "init"
        };
        cache.mboxes[mbox].count += 1;
        queueRequest();
        return function() {
            cache.mboxes[mbox].count -= 1;
        };
    };
    var cache = {
        mboxes: {},
        queuedUpdates: [],
        profiles: {},
        events: {},
        activeRequests: []
    };
    var filterRequests = function(requestPromise) {
        return function() {
            cache.activeRequests = cache.activeRequests.filter(function(activeRequest) {
                return activeRequest !== requestPromise;
            });
        };
    };
    var updateTimeout;
    // We batch requests
    var requestTimeout;
    return {
        cache: cache,
        getProfile: getProfile,
        on: on,
        postUpdate: postUpdate,
        queueUpdate: queueUpdate,
        register: register,
        doRequest: doRequest,
        queueRequest: queueRequest
    };
}
export default createProfileManager;

//# sourceMappingURL=manager.js.map